/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineComponent } from 'vue';
import { defineModule } from 'direct-vuex';
import { moduleActionContext, moduleGetterContext } from '@/plugins/vuex';
import { MigrateOptions } from '@aison/migrator';
import { run } from '@/api';

export interface MigrationState {
  migrations: MigrateOptions[];
  currentMigrationIndex: number;
  migrationLoading: boolean;
  migrationError?: object;
  migrationSuccess: boolean;
  responseLog: any[];
}

const module = defineModule({
  namespaced: true,
  state: (): MigrationState => {
    return {
      migrations: [],
      currentMigrationIndex: 0,
      // TODO Ev. split to two modules
      responseLog: [],
      migrationLoading: false,
      migrationError: undefined,
      migrationSuccess: false,
    };
  },
  getters: {
    currentMigration: (...args) => {
      const { state } = migrationGetterContext(args);
      return state.migrations[state.currentMigrationIndex];
    },
    responseLog: (...args) => migrationGetterContext(args).state.responseLog,
  },
  mutations: {
    setCurrentIndex(state, value: number) {
      state.currentMigrationIndex = value;
    },
    setCurrentMigration(state, options: MigrateOptions) {
      state.migrations[state.currentMigrationIndex] = options;
    },
    updateCurrentMigration(state, options: MigrateOptions) {
      state.migrations[state.currentMigrationIndex] = {
        ...state.migrations[state.currentMigrationIndex],
        ...options,
      };
    },
    delete(state, index: number) {
      // TODO: Need to handle currentMigrationIndex getting out of bounds
      delete state.migrations[index];
    },
    new(state) {
      state.migrations.push({ source: {}, transform: [], target: {} } as any);
      state.currentMigrationIndex = state.migrations.length - 1;
    },
    clearResponseLog(state) {
      state['responseLog'] = [];
    },
    addResponseLogItem(state, item: string) {
      if (item && item.length) {
        state.responseLog.push(JSON.parse(item));
      }
    },
    setMigrationLoading(state) {
      state.migrationLoading = true;
      state.migrationError = undefined;
    },
    setMigrationError(state, error: object) {
      state.migrationLoading = false;
      state.migrationError = error;
    },
    setMigrationSuccess(state, success: boolean) {
      state.migrationSuccess = success;
      state.migrationLoading = false;
      if (success) {
        state.migrationError = undefined;
      }
    },
  },
  actions: {
    loadConfig(context, payload: MigrateOptions) {
      const { rootCommit } = migrationActionContext(context);
      const { source, transform, target } = payload;
      // console.log('load config!', payload);
      rootCommit.source.reset(source);
      rootCommit.read.reset(source);
      if (transform && transform.length) {
        rootCommit.transform.reset(transform[0]);
      } else {
        rootCommit.transform.reset([]);
      }
      rootCommit.target.reset(target);
    },
    // delete(context, payload: number) {
    //   const { commit } = migrationActionContext(context);
    // },
    new(context) {
      const { commit, rootCommit } = migrationActionContext(context);
      commit.new(null);
      rootCommit.source.reset({});
      rootCommit.transform.reset([]);
      rootCommit.target.reset({});
    },
    change(context, payload: number) {
      const {
        // state,
        commit,
        getters,
        // rootCommit,
        rootDispatch,
      } = migrationActionContext(context);
      // console.log(
      //   '\n\n\nwill change current migration, current index',
      //   state.currentMigrationIndex
      // );
      // TODO: Guard for out of bounds?
      commit.setCurrentIndex(payload);
      // console.log('currentMigration?', getters.currentMigration);
      const { source, target, transform } = getters.currentMigration;
      // console.log('changed to source', source);
      rootDispatch.source.reset(source);
      rootDispatch.transform.reset(transform);
      rootDispatch.target.reset(target);
      // console.log(
      //   'changed migration, current index',
      //   state.currentMigrationIndex
      // );
    },
    reset(context) {
      const { rootCommit } = migrationActionContext(context);
      rootCommit.source.reset({});
      rootCommit.read.reset({});
      rootCommit.transform.reset([]);
      rootCommit.target.reset({});
    },
    updateCurrentMigration(context, payload) {
      const { commit } = migrationActionContext(context);
      // console.log('update current migration hit');
      commit.updateCurrentMigration(payload);
    },
    async runMigration(context) {
      const { commit, getters } = migrationActionContext(context);
      commit.clearResponseLog(null);
      commit.setMigrationLoading(null);
      try {
        await run.migrate(getters.currentMigration, {
          onData: data => {
            const lines = data.split('\n');
            lines.map(commit.addResponseLogItem);
            // console.log('got data!', data);
          },
        });

        // console.log('res?', res);
        // const result = await new Promise((resolve, reject) => {
        //   res.body?.on('data', data =>
        //     commit.addResponseLogItem(data.toString())
        //   );
        //   res.body?.on('error', reject);
        //   res.body?.on('end', resolve);
        // });
        // console.log('finished migration, result?', res);
        commit.setMigrationSuccess(true);
      } catch (e) {
        // console.log('error!', e);
        commit.setMigrationError(e);
      }
    },
    clearResponseLog(context) {
      const { commit } = migrationActionContext(context);
      commit.clearResponseLog(null);
    },
  },
});

const migrationGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, module);
const migrationActionContext = (context: any) =>
  moduleActionContext(context, module);

export default module;
